import { useMemo } from 'react';

import { ZoomInIcon, ZoomOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import ToolkitControlsWrapper from '@/components/organisms/Dialogs/Node/ToolkitControls/ToolkitControlsWrapper/ToolkitControlsWrapper';
const ToolkitControlsZoom = ({ onZoomInClick, onZoomOutClick, zoomPercentage }) => {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        label: t('common.zoom_in'),
        icon: <ZoomInIcon size={16} className="text-foreground" />,
        onClick: onZoomInClick,
        shouldFocus: true,
      },
      {
        label: t('common.percentage', { 0: zoomPercentage }),
        icon: (
          <span className="text-xs leading-4 font-semibold text-muted-foreground uppercase">
            {zoomPercentage}
          </span>
        ),
      },
      {
        label: t('common.zoom_out'),
        icon: <ZoomOutIcon size={16} className="text-foreground" />,
        onClick: onZoomOutClick,
        shouldFocus: true,
      },
    ],
    [onZoomInClick, onZoomOutClick, t, zoomPercentage]
  );

  return <ToolkitControlsWrapper items={items} />;
};

export default ToolkitControlsZoom;
